import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import exceljs from './plugins/exceljs'
import filesaver from './plugins/filesaver'
import swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'

Vue.config.productionTip = false
Vue.use({
  install: function (Vue) {
    Vue.prototype.$exceljs = exceljs
    Vue.prototype.$filesaver = filesaver
    Vue.prototype.$swal = swal
  },
  
})

Vue.filter("thousandSeprator",(number, decimals = 2)=>{
 return new Intl.NumberFormat("en-PH", {style:"currency",currency: "PHP",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals }).format(number)
})
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
